import { EditLocationModal } from "../modals/EditLocationModal";
import { MODAL_TYPES, ModalType } from "../../constants";
import { useProfiles } from "../../hooks";

interface EditLocationModalWrapperProps {
  currentModal: ModalType;
  isModalOpen: (modalType: ModalType) => boolean;
  locationId: number | null;
  storedCraneId: number | null;
  onClose: () => void;
  refreshInterval?: number;
}

export const EditLocationModalWrapper = ({
  currentModal,
  isModalOpen,
  locationId,
  storedCraneId,
  onClose,
  refreshInterval,
}: EditLocationModalWrapperProps) => {
  const { isSupervisor, isOperator, hasMESSupervisorRole } = useProfiles();

  // Early returns for permissions and modal state
  if (
    (!isSupervisor && !isOperator) ||
    !isModalOpen(MODAL_TYPES.LOCATION_CONTENT_EDITION)
  )
    return null;

  // Ensure all required props are available before rendering
  if (!locationId || !storedCraneId || storedCraneId === null) return null;

  return (
    <EditLocationModal
      show={currentModal === MODAL_TYPES.LOCATION_CONTENT_EDITION}
      onHide={onClose}
      locationId={locationId}
      selectedCraneId={storedCraneId}
      refreshInterval={refreshInterval}
      canClearLocation={hasMESSupervisorRole} // only MES Supervisors can clear locations
    />
  );
};
